// msalConfig.js
import { PublicClientApplication } from "@azure/msal-browser";

const msalConfig = {
  auth: {
    clientId: "e4710eb8-3b9d-469e-bc26-3e1bad4045c1", // Replace with your Azure AD app's client ID
    authority: "https://login.microsoftonline.com/3cfcb219-4834-4845-a471-11a3f549a36c", // Replace with your tenant ID or common for multi-tenant apps
    redirectUri: "https://sso.softwriters.com/dashboard", // URL to redirect to after login, should match the redirect URI in Azure AD
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set to true if you're having issues on IE11 or Edge
  },
};

// Initialize MSAL instance
export const msalInstance = new PublicClientApplication(msalConfig);
